// ./src/locales/translations/enUS.ts
import ptBR from './ptBR';

const enUS: typeof ptBR = {
  // language: 'en-US',
  Home2: {
    sidebar: {
      assistance: 'Home',
      our_plans: 'Our Plans',
      to_partners: 'To partners',
      to_providers: 'To providers',
      customer_area: "Customer's area",
    },
    header: {
      assistance: 'Home',
      our_plans: 'Our Plans',
      to_partners: 'To partners',
      to_providers: 'To providers',
      customer_area: "Customer's area",
    },
    assistance: {
      title: 'Vehicle assistance 24 hours a day',
      subtitle: 'We are here to help you. What do you need?',
    },
    cards_options: {
      winch: 'Winch',
      tire_change: 'Tire change',
      battery_recharge: 'Battery recharge',
      locksmith: 'Locksmith',
      fuel: 'Fuel',
      mechanical_relief: 'Mechanical relief',
    },
    contacts: {
      or_call: 'or call',
      number_telephone: '0800 100 1100',
      app_android_ios: 'app android and IOS',
      download_now: 'Download now',
    },
    footer: {
      terms: 'Terms of use and privacy policies',
      contact_us: 'Contact us',
    },
  },
};

export default enUS;
